exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll-container[data-v-be6b7bae] {\n  white-space: nowrap;\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n}\n.scroll-container[data-v-be6b7bae]  .el-scrollbar__bar {\n  bottom: 0px;\n}\n.scroll-container[data-v-be6b7bae]  .el-scrollbar__wrap {\n  padding-top: 4px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 49px;\n}", ""]);

// exports
